<template>
	<div class="device-basic-info">
		<gc-group-detail :data="deviceBasicInfo"></gc-group-detail>
	</div>
</template>

<script>
export default {
	props: {
		deviceBasicInfo: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {}
	},
	created() {},
}
</script>
<style lang="scss" scoped></style>
